(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nwf-product-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nwf-product-carousel')) {
    customElements.define('nwf-product-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.track = this.querySelector('[data-track]');
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        if (!this.track || !this.slides.length) return;
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.index = 0;
        this.targetIndex = null;
        this.nav = this.querySelector('[data-nav]');
        this.items = Array.from(this.querySelectorAll('[data-nav-item]'));
        this.previous = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        this.counter = this.querySelector('[data-current]');
        this.status = this.querySelector('[data-status]');
        this.rotation = this.querySelector('[data-rotation]');
        this.progress = this.querySelector('[data-progress]');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.autoplayEnabled = this.dataset.autoplay === 'true' && this.slides.length > 1;
        this.userPaused = this.reducedMotion.matches || this.dataset.editor === 'true';
        this.interval = Math.max(4000, Number(this.dataset.interval) || 6000);
        this.hovered = false;
        this.inView = false;
        this.querySelector('[data-controls]').hidden = this.slides.length < 2;
        this.previous.addEventListener('click', () => { this.pauseAutoplay(); this.goTo((this.targetIndex ?? this.index) - 1); }, {signal});
        this.next.addEventListener('click', () => { this.pauseAutoplay(); this.goTo((this.targetIndex ?? this.index) + 1); }, {signal});
        this.rotation?.addEventListener('click', () => {
          this.userPaused = !this.userPaused;
          this.hovered = false;
          this.scheduleAutoplay();
        }, {signal});
        this.addEventListener('pointerenter', event => {
          if (event.pointerType !== 'mouse' && event.pointerType !== 'pen') return;
          this.hovered = true;
          this.scheduleAutoplay();
        }, {signal});
        this.addEventListener('pointerleave', event => {
          if (event.pointerType !== 'mouse' && event.pointerType !== 'pen') return;
          this.hovered = false;
          this.scheduleAutoplay();
        }, {signal});
        this.addEventListener('focusin', event => {
          if (event.target !== this.rotation || event.target.matches(':focus-visible')) this.pauseAutoplay();
        }, {signal});
        document.addEventListener('visibilitychange', () => this.scheduleAutoplay(), {signal});
        this.reducedMotion.addEventListener('change', () => {
          if (this.reducedMotion.matches) this.pauseAutoplay();
        }, {signal});
        this.items.forEach((item, index) => item.addEventListener('click', event => {
          event.preventDefault();
          this.pauseAutoplay();
          this.goTo(index);
        }, {signal}));
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track) return;
          const current = this.targetIndex ?? this.index;
          const positions = {ArrowLeft: current - 1, ArrowRight: current + 1, Home: 0, End: this.slides.length - 1};
          if (!(event.key in positions)) return;
          event.preventDefault();
          this.pauseAutoplay();
          this.goTo(positions[event.key]);
        }, {signal});
        this.track.addEventListener('pointerdown', () => { this.pauseAutoplay(); this.targetIndex = null; }, {passive: true, signal});
        this.track.addEventListener('wheel', event => {
          this.targetIndex = null;
          if (event.deltaX) this.pauseAutoplay();
        }, {passive: true, signal});
        this.track.addEventListener('scroll', () => {
          if (this.targetIndex === null && !this.frame) {
            this.frame = requestAnimationFrame(() => {
              this.update(this.nearest());
              this.frame = null;
            });
          }
          clearTimeout(this.settle);
          this.settle = setTimeout(() => {
            this.targetIndex = null;
            this.update(this.nearest());
            this.status.textContent = this.slides[this.index].dataset.announcement;
          }, 140);
        }, {passive: true, signal});
        this.lastWidth = this.track.clientWidth;
        this.observer = new ResizeObserver(() => {
          const width = this.track.clientWidth;
          if (width && width !== this.lastWidth) {
            this.lastWidth = width;
            this.targetIndex = null;
            this.track.scrollTo({left: this.index * width, behavior: 'instant'});
          }
        });
        this.observer.observe(this.track);
        this.visibilityObserver = new IntersectionObserver(entries => {
          const visible = entries[0].isIntersecting && entries[0].intersectionRatio >= .2;
          if (visible !== this.inView) {
            this.inView = visible;
            this.scheduleAutoplay();
          }
        }, {threshold: [0, .2]});
        this.visibilityObserver.observe(this);
        document.addEventListener('shopify:block:select', event => {
          const selected = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (selected >= 0) { this.pauseAutoplay(); this.goTo(selected, true); }
        }, {signal});
        this.update(0);
        this.scheduleAutoplay();
      }
      cancelAutoplay() {
        clearTimeout(this.autoplayTimer);
        clearTimeout(this.wrapTimer);
        this.autoplayTimer = null;
        this.wrapTimer = null;
        this.progressAnimation?.cancel();
        this.track?.classList.remove('nwf-carousel__track--reset');
      }
      pauseAutoplay() {
        this.userPaused = true;
        this.scheduleAutoplay();
      }
      scheduleAutoplay() {
        this.cancelAutoplay();
        const playing = this.autoplayEnabled && !this.userPaused && !this.hovered && this.inView && !document.hidden;
        this.dataset.playing = String(playing);
        this.status.setAttribute('aria-live', playing ? 'off' : 'polite');
        if (this.rotation) {
          this.rotation.dataset.paused = String(this.userPaused);
          this.rotation.setAttribute('aria-label', this.userPaused ? this.rotation.dataset.playLabel : this.rotation.dataset.pauseLabel);
        }
        if (!playing) return;
        if (!this.reducedMotion.matches) this.progressAnimation = this.progress.animate([{transform:'scaleX(0)'},{transform:'scaleX(1)'}], {duration:this.interval, easing:'linear', fill:'forwards'});
        this.autoplayTimer = setTimeout(() => {
          if (this.index === this.slides.length - 1 && !this.reducedMotion.matches) {
            this.track.classList.add('nwf-carousel__track--reset');
            this.wrapTimer = setTimeout(() => {
              this.goTo(0, true);
              this.scheduleAutoplay();
            }, 180);
          } else {
            this.goTo((this.index + 1) % this.slides.length);
            this.scheduleAutoplay();
          }
        }, this.interval);
      }
      nearest() {
        return Math.max(0, Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / (this.track.clientWidth || 1))));
      }
      goTo(index, instant = false) {
        const target = Math.max(0, Math.min(this.slides.length - 1, index));
        this.targetIndex = target;
        this.update(target);
        this.track.scrollTo({left: target * this.track.clientWidth, behavior: instant || this.reducedMotion.matches ? 'instant' : 'smooth'});
        if (this.nearest() === target) {
          this.targetIndex = null;
          this.status.textContent = this.slides[target].dataset.announcement;
        }
      }
      update(index) {
        this.index = index;
        this.counter.textContent = String(index + 1).padStart(2, '0');
        this.previous.disabled = index === 0;
        this.next.disabled = index === this.slides.length - 1;
        this.slides.forEach((slide, position) => {
          slide.inert = position !== index;
          slide.setAttribute('aria-hidden', String(position !== index));
        });
        this.items.forEach((item, position) => item.setAttribute('aria-current', String(position === index)));
        const item = this.items[index];
        if (item && this.nav) {
          const left = item.offsetLeft;
          const right = left + item.offsetWidth;
          if (left < this.nav.scrollLeft || right > this.nav.scrollLeft + this.nav.clientWidth) {
            this.nav.scrollTo({left: Math.max(0, left - (this.nav.clientWidth - item.offsetWidth) / 2), behavior: 'instant'});
          }
        }
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.abort = null;
        this.observer?.disconnect();
        this.visibilityObserver?.disconnect();
        this.cancelAutoplay();
        clearTimeout(this.settle);
        cancelAnimationFrame(this.frame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
